import { render, staticRenderFns } from "./MarketplaceHistory.vue?vue&type=template&id=e6227cf0&"
import script from "./MarketplaceHistory.vue?vue&type=script&lang=js&"
export * from "./MarketplaceHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports